import { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { TabOptions } from "@/constants/Home";
import { ButtonArrows } from "../Helpers/Arrows";
import { ProductByBreakPoints } from "@/constants/BreakPoints";
import { useRouter } from "next/router";

const ProductCard = dynamic(() => import("./ProductCard"), { ssr: false });
import GetProductsByCategoryId from "@/services/home/DataByByCategoryId";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";
import { getCookies } from "cookies-next";

function ProductsBy({
  multi,
  active,
  width = "w-[80%]",
  setActive,
  breakpoints,
  title,
  products: productsData,
  show = true,
  data,
  dynamicSeeMore,
  singleLink,
  showBackordersAnyway,
  categoryID,
  // noOutOfStockProducts,
}) {
  const [swiper, set_swiper] = useState({});
  const { t } = useTranslation("common");
  const { locale, push } = useRouter();
  const { region_id } = getCookies();

  const products = productsData.map((product) =>
    product?._source ? product?._source : product
  );
  const [fullData, setfullData] = useState([...products]);

  useEffect(() => {
    const newProducts = productsData.map((product) =>
      product?._source ? product?._source : product
    );
    setfullData([...newProducts]);
  }, [productsData]);

  // Client

  let dataOfTabsClient = useRef();

  useEffect(() => {
    const fetchClientData = async () => {
      if (active || categoryID) {
        dataOfTabsClient.current = await GetProductsByCategoryId({
          handshake: undefined,
          title: "daily-deals => Client",
          categoryID:
            typeof active == "number" ? data[active].category_id : categoryID,
          locale,
          region_id,
          amountOfData: 16,
          dataStart: 0,
          dataTo: 15,
        });

        if (dataOfTabsClient?.current.products.length > 0) {
          const newProductsClient = dataOfTabsClient?.current.products.map(
            (product) => (product?._source ? product?._source : product)
          );
          setfullData([...newProductsClient]);
        }
      }
    };
    fetchClientData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productsData, categoryID, data, active]);

  return fullData && fullData.length ? (
    <div
      className={`${width} max-[570px]:w-[98%] mx-auto max-[570px]:mt-4 my-10 relative bg-white p-2 rounded-md`}
    >
      <div className="flex flex-wrap items-center justify-between">
        {multi ? (
          <ul className="flex items-center">
            {TabOptions.map((_, i) => (
              <li
                key={i}
                className={`transition-all duration-500 cursor-pointer
                ${active === i && "bg-blue campaign:bg-campaignAccent text-white"} border`}
              >
                <button
                  aria-label="Data Title"
                  onClick={() => setActive(i)}
                  className="max-[570px]:text-[13px] py-3.5 px-7 max-[768px]:px-4 max-[570px]:px-2"
                >
                  {locale === "en" ? data[i]?.title : data[i]["title-ar"]}
                </button>
              </li>
            ))}
          </ul>
        ) : (
          <h2 className="text-xl max-sm:text-[15px] font-semibold text-blue">
            {title}
          </h2>
        )}
        {fullData?.length > 5 ? (
          <ButtonArrows
            {...{
              swiper,
              t,
              multi,
              show,
              active,
              dynamicSeeMore,
              data,
              singleLink,
            }}
          />
        ) : null}
      </div>
      <div className="my-4">
        <Swiper
          spaceBetween={12}
          // slidesPerGroup={5}
          dir={locale === "ar" ? "rtl" : "ltr"}
          key={locale}
          breakpoints={breakpoints || ProductByBreakPoints}
          onInit={(e) => set_swiper(e)}
        >
          {fullData && fullData.length
            ? fullData?.map((product) =>
                !showBackordersAnyway ? (
                  product?.show_outofstock &&
                  product?.show_outofstock[0] == true ? (
                    <SwiperSlide key={product?._source?.sku}>
                      <ProductCard {...{ t, product }} />
                    </SwiperSlide>
                  ) : product?.stock?.is_in_stock ? (
                    <SwiperSlide key={product?._source?.sku}>
                      <ProductCard {...{ t, product }} />
                    </SwiperSlide>
                  ) : null
                ) : (
                  <SwiperSlide key={product?._source?.sku}>
                    <ProductCard {...{ t, product }} />
                  </SwiperSlide>
                )
              )
            : null}
        </Swiper>
      </div>
      {show ? (
        <button
          suppressHydrationWarning
          onClick={
            data
              ? () => push(`/${data[active]["category-url"]}`)
              : () => push("")
          }
          className={`p-3 hidden w-full ${
            multi && "max-[768px]:block"
          } px-2 text-sm border border-blue text-blue
          rounded-md transition-all duration-500 hover:bg-blue
          hover:text-white`}
        >
          {t("show")}
        </button>
      ) : null}
    </div>
  ) : null;
}

export default ProductsBy;
